import axiosInstance from "./axios";

export const fetchMealsTrackingStatus = async () =>
  axiosInstance
    .get("/clients/meals-in-take-tracking")
    .then((response) => response.data);

export const registerMealIntakeRequest = async (requestData) =>
  axiosInstance
    .post("/clients/meals-in-take-tracking", requestData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
